import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

import FieldsSelect from '../common/FieldsSelect';

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .not-valid {
    outline: solid red 1px;
  }

  .fields-select {
    width: 250px;
  }
`;

// TODO: this justifyContent prop is SHIT
const EventsFieldOption = ({
  onChange,
  label,
  value,
  values,
  disabled,
  visible,
  showNotValidFields = false,
  allowClear = true,
}) => {
  const [isValid, setValid] = useState(true);

  useEffect(() => {
    if (showNotValidFields) {
      setValid(!!value);
    }
  }, [value, showNotValidFields]);

  return visible ? (
    <StyledDiv>
      {label}
      <FieldsSelect
        onSelect={onChange}
        value={value}
        fields={values}
        disabled={disabled}
        allowClear={allowClear}
        selectClassName={classNames('fields-select', { 'not-valid': !isValid })}
      />
    </StyledDiv>
  ) : null;
};

export default EventsFieldOption;
